var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import { Tab, Tabs } from '../../..';
import * as Styles from './styles';
import { TabContent } from './utils/TabContent';
import { sendClickEvent } from '../../utils/sendClickEvent';
import { StaticFooter } from '../Static';
import { contentLinks } from './utils/LinksTabContent';
/**
 * Componente Footer do Design System OLX
 */
export const NewFooter = _a => {
  var {
      firstGroupTabLinks,
      secondGroupTabLinks,
      thirdGroupTabLinks,
      newMaxWidth
    } = _a,
    props = __rest(_a, ["firstGroupTabLinks", "secondGroupTabLinks", "thirdGroupTabLinks", "newMaxWidth"]);
  const componentName = 'footer';
  const showTabs = (firstGroupTabLinks === null || firstGroupTabLinks === void 0 ? void 0 : firstGroupTabLinks.title) || (secondGroupTabLinks === null || secondGroupTabLinks === void 0 ? void 0 : secondGroupTabLinks.title) || (thirdGroupTabLinks === null || thirdGroupTabLinks === void 0 ? void 0 : thirdGroupTabLinks.title);
  const handleChange = id => {
    if (id === 'ds-tab-primario') {
      sendClickEvent('first_tab', componentName);
    }
    if (id === 'ds-tab-secundario') {
      sendClickEvent('second_tab', componentName);
    }
    if (id === 'ds-tab-links-uteis') {
      sendClickEvent('third_tab', componentName);
    }
  };
  return React.createElement(Styles.FooterWrapper, {
    id: "footer",
    "data-ds-component": "DS-Footer"
  }, showTabs && React.createElement(Tabs, {
    isPersistent: true,
    onChange: handleChange
  }, (firstGroupTabLinks === null || firstGroupTabLinks === void 0 ? void 0 : firstGroupTabLinks.title) ? React.createElement(Tab, {
    id: "ds-tab-primario",
    label: firstGroupTabLinks.title
  }, React.createElement(TabContent, null, contentLinks(firstGroupTabLinks))) : React.createElement(React.Fragment, null), (secondGroupTabLinks === null || secondGroupTabLinks === void 0 ? void 0 : secondGroupTabLinks.title) ? React.createElement(Tab, {
    id: "ds-tab-secundario",
    label: secondGroupTabLinks.title
  }, React.createElement(TabContent, null, contentLinks(secondGroupTabLinks))) : React.createElement(React.Fragment, null), (thirdGroupTabLinks === null || thirdGroupTabLinks === void 0 ? void 0 : thirdGroupTabLinks.title) ? React.createElement(Tab, {
    id: "ds-tab-links-uteis",
    label: thirdGroupTabLinks.title
  }, React.createElement(TabContent, null, contentLinks(thirdGroupTabLinks))) : React.createElement(React.Fragment, null)), React.createElement(StaticFooter, {
    componentName: componentName
  }));
};
export default NewFooter;